import { css } from '@emotion/react'
import { Card, colors, mq } from 'plume-ui'
import React, { useEffect } from 'react'
import { NPFeedSearchResult } from '../../../types'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { EmptyCard } from '../../common/EmptyCard'
import { NewsPicksFeedSearchResultItem } from '../../common/npStartup/NewsPicksSearchResult'
import { printError } from '@/lib/log'
import { fetchNPFeedsByInvestorShortname } from '@/lib/api/np/feed'

type Props = {
  className?: string
  investorShortname: string
}

export const NewsPicksNewsList: React.VFC<Props> = (props) => {
  const className = props.className
    ? [props.className, 'np-feeds'].join(' ')
    : 'np-feeds'

  const [npFeeds, setNpFeeds] = React.useState<NPFeedSearchResult[] | null>(
    null
  )

  useEffect(() => {
    setNpFeeds(null)
    fetchNPFeedsByInvestorShortname(props.investorShortname)
      .then((r) => {
        setNpFeeds(r)
      })
      .catch((e) => printError(e))
  }, [props.investorShortname])

  if (!npFeeds) return null
  const newsPicksFeeds = npFeeds.slice(0, 10)

  return (
    <Card
      className={className}
      css={css`
        margin-block-start: 16px;
        ${mq.large} {
          margin-block-start: 24px;
        }
      `}
    >
      <CardInnerTitle
        title="NewsPicksの検索結果"
        helpText="検索結果について"
        helpLink="https://help.initial.inc/ja/articles/5676034"
      />
      <div
        css={css`
          & > :not(:last-child) {
            border-bottom: 1px solid ${colors.gray50};
          }
        `}
      >
        {npFeeds.length !== 0 ? (
          newsPicksFeeds.map((feed, i) => (
            <NewsPicksFeedSearchResultItem
              key={i}
              index={i}
              {...feed}
              classPrefix="investorpage"
            />
          ))
        ) : (
          <EmptyCard />
        )}
      </div>
    </Card>
  )
}
